import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { fetchGetQuestionsType } from "../miscellaneous/fetchGetQuestionsType";
import { fetchGetTasksType } from "../miscellaneous/fetchGetTasksType";
import { fetchCreateTaskTemplate } from "../miscellaneous/fetchCreateTaskTemplate";
import { fetchGetJobsByCompanyId } from "../../jobs-management/miscellaneous/fetchGetJobsByCompanyId";
import { fetchGetCompaniesByParent } from "../../organization-management/miscellaneous/fetchGetCompaniesByParent";
import { fetchGetAllParentCompanies } from "../../user-management/miscellaneous/fetchGetAllParentCompanies";

export const useCreateTemplate = () => {
  const [parentCompanies, setParentCompanies] = useState<any[]>([]);
  const [companiesName, setCompaniesName] = useState([]);
  const [jobTitle, setJobTitle] = useState([]);
  const [questionsType, setQuestionType] = useState([]);
  const [tasksType, setTasksType] = useState([]);

  const navigate = useNavigate();

  const mutationGetParentCompanies = useMutation(fetchGetAllParentCompanies, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const companies = _.map(res.data.data, (item: any) => {
          return { name: item.companyName, value: item.id };
        });
        setParentCompanies(companies);
      }
    },
    onError: () => {},
  });

  const mutationGetCompanies = useMutation(fetchGetCompaniesByParent, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const companyName = _.map(res.data.data, (item) => {
          return { name: item.companyName, value: item.id };
        });
        setCompaniesName(companyName as any);
      }
    },
    onError: () => {},
  });

  const mutationGetQuestionType = useMutation(fetchGetQuestionsType, {
    onSuccess: (res) => {
      if (res.status === 200) {
        setQuestionType(res.data);
      }
    },
    onError: () => {},
  });

  const mutationGetTaskType = useMutation(fetchGetTasksType, {
    onSuccess: (res) => {
      if (res.status === 200) {
        setTasksType(res.data);
      }
    },
    onError: () => {},
  });

  const mutationCreateTemplate = useMutation(fetchCreateTaskTemplate, {
    onSuccess: (res) => {
      if (res.status === 200) {
        navigate("/tasks-list-management");
      }
    },
    onError: () => {},
  });

  const mutationGetJobsByCompany = useMutation(fetchGetJobsByCompanyId, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const jobs = _.map(res.data.data ?? [], (item) => {
          return { id: item.id, title: item.title };
        });

        setJobTitle(jobs as any);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    const userRole = !!localStorage.getItem("rolesJson")
      ? JSON.parse(localStorage.getItem("rolesJson") as string)
      : [];

    const isRoleAdmin =
      userRole &&
      userRole.length > 0 &&
      userRole[0]?.Name &&
      userRole[0]?.Name.toLowerCase() === "admin";

    const parentCompanyId = localStorage.getItem("parentCompanyId") ?? "";
    const parentCompanyName = localStorage.getItem("parentCompanyName") ?? "";

    if (isRoleAdmin && parentCompanyId) {
      setParentCompanies([{ value: parentCompanyId, name: parentCompanyName }]);
      mutationGetCompanies.mutate(parentCompanyId);
    } else {
      mutationGetParentCompanies.mutate();
    }
    mutationGetQuestionType.mutate();
    mutationGetTaskType.mutate();
  }, []);

  return {
    mutationCreateTemplate,
    mutationGetJobsByCompany,
    mutationGetCompanies,
    parentCompanies,
    companiesName,
    jobTitle,
    tasksType,
    questionsType,
  };
};
